import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const TransactionDetails = ({ transaction, open, onClose }) => {
  const { t } = useTranslation();

  if (!transaction) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("transactionDetails.title")}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color="textSecondary">
              {t("transactionDetails.transactionId")}
            </Typography>
            <Typography variant="body1">{transaction.id}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="textSecondary">
              {t("transactionDetails.type")}
            </Typography>
            <Typography variant="body1">
              {t(`transactions.types.${transaction.type}`, {
                defaultValue: transaction.type.replace("_", " ").toUpperCase(),
              })}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="textSecondary">
              {t("transactionDetails.amount")}
            </Typography>
            <Typography variant="body1">
              ${Math.abs(transaction.amount).toFixed(2)}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="textSecondary">
              {t("transactionDetails.status")}
            </Typography>
            <Typography
              variant="body1"
              color={
                transaction.status === "completed"
                  ? "success.main"
                  : "error.main"
              }
            >
              {t(`status.${transaction.status}`, {
                defaultValue: transaction.status.toUpperCase(),
              })}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="textSecondary">
              {t("transactionDetails.date")}
            </Typography>
            <Typography variant="body1">
              {new Date(transaction.createdAt).toLocaleString()}
            </Typography>
          </Grid>

          {transaction.metadata && (
            <Grid item xs={12}>
              <Typography color="textSecondary">
                {t("transactionDetails.additionalDetails")}
              </Typography>
              <Box sx={{ mt: 1, p: 1, bgcolor: "grey.100", borderRadius: 1 }}>
                <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                  {JSON.stringify(transaction.metadata, null, 2)}
                </pre>
              </Box>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.actions.close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransactionDetails;
